import { ETH } from '../constants/assets'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const INK = {
  name: 'ink',
  chainId: 57073,
  averageBlockTimeSeconds: 1,
  explorerUrl: 'https://explorer.inkonchain.com',
  nativeAsset: ETH,
  slip44: 60,
  wrappedNativeAsset: '0x4200000000000000000000000000000000000006',
  blockscoutApiUrl: 'https://explorer.inkonchain.com/api',
  etherscanSupported: false,
  publicRpcUrls: ['https://rpc-gel.inkonchain.com/', 'https://rpc-qnd.inkonchain.com'],
  getPrivateRpcUrls: () => {
    const rpcs: string[] = []
    process.env.ROUTEME_API_KEY && rpcs.push(`https://lb.routeme.sh/rpc/57073/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('ink')
    quickNodeUrl && rpcs.push(quickNodeUrl)
    process.env.GELATO_INK_API_KEY && rpcs.push(`https://rpc-gel.inkonchain.com/${process.env.GELATO_INK_API_KEY}`)
    process.env.ALCHEMY_API_KEY && rpcs.push(`https://ink-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    return rpcs
  },
} as const satisfies ChainConfig
